import React from 'react';
import '../css/Nav.css';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import FhLogo from '../images/FHText.svg';

const NavbarComponent = () => {
  // const location = useLocation();

  return (
    <Navbar
      id="navbar"
      bg="dark"
      variant="dark"
      expand="lg"
      sticky="top"
      className="navbar-custom"
    >
      <Container>
        {/* Logo links to home */}
        <Navbar.Brand as={NavLink} to="/" className="fh-logo-container">
          <img src={FhLogo} alt="FH Logo" className="fh-logo" />
        </Navbar.Brand>

        {/* Toggle Button for mobile */}
        <Navbar.Toggle aria-controls="navbar-nav" />

        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              as={NavLink}
              to="/services"
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              Services
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/about"
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              About
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/contact"
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;
